import axios from "axios";
import {
	BaseResponse,
	District,
	DistrictListResponse,
	DistrictPayload,
	DistrictResponse,
} from "../types/district.type";

const API_URL = import.meta.env.VITE_APP_API_URL;

export const fetchDistrictList = async (
	page = 1,
	limit = 10,
	search = "",
): Promise<any> => {
	// Check if we want the full list (no pagination) vs a paged list
	const endpoint =
		limit === 1000
			? `${API_URL}/admin/master/districts`
			: `${API_URL}/admin/district/list?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`;
	const response = await axios.get(endpoint);

	// The API might return the array directly or inside a data property
	const data = response.data.data || response.data;

	if (Array.isArray(data)) {
		return {
			items: data,
			totalItems: data.length,
			totalPages: 1,
			currentPage: 1,
		};
	}

	// If it's already in the expected format { items: [], totalItems: X }
	if (data && data.items) {
		return data;
	}

	// Fallback for unexpected formats
	return { items: [], totalItems: 0 };
};

export const fetchDistrictById = async (
	id: string | number,
): Promise<District> => {
	const response = await axios.get(`${API_URL}/admin/district/view/${id}`);
	return response.data.data;
};

export const createDistrict = async (
	payload: DistrictPayload,
): Promise<DistrictResponse> => {
	const response = await axios.post(`${API_URL}/admin/district/add`, payload);
	return response.data;
};

export const updateDistrict = async (
	id: string | number,
	payload: DistrictPayload,
): Promise<DistrictResponse> => {
	const response = await axios.put(
		`${API_URL}/admin/district/edit/${id}`,
		payload,
	);
	return response.data;
};

export const deleteDistrict = async (
	id: string | number,
): Promise<BaseResponse> => {
	const response = await axios.delete(`${API_URL}/admin/district/delete/${id}`);
	return response.data;
};
